/* eslint-disable no-prototype-builtins */
/* eslint-disable class-methods-use-this */
import { MusicVideoScenesFeedResponse } from 'api/interface/MusicVideoScenesDataResponse.ts';

export class IntermediateMediaFormatter {
	getMusicVideoSceneDataItems = (feedItemsResponse: MusicVideoScenesFeedResponse) => {
		const {
			id: mediaId,
			generation_id: generationId,
			type,
			state,
			status,
			audio: audioDetails,
			aspect_ratio: aspectRatio,
			scenes,
		} = feedItemsResponse;
		return {
			mediaId,
			generationId,
			type,
			state,
			status,
			audioDetails,
			aspectRatio,
			scenes,
		};
	};
}
/* eslint-enable no-prototype-builtins */
/* eslint-enable class-methods-use-this */
